import { forwardRef, useImperativeHandle, useRef } from 'react';
import styles from './label.module.css';
import clsx from 'clsx';

export type LabelProps = React.ComponentPropsWithoutRef<'label'> & {
  internal?: 'small';
};

// props.hidden visually hides label element, but still make available for screen readers
export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, ...rest },
  ref
) {
  const innerRef = useRef<HTMLLabelElement>(null);

  useImperativeHandle(ref, () => innerRef.current as HTMLLabelElement); // Forward innerRef

  return (
    <label
      className={clsx(
        styles.label,
        !!rest.internal && styles[`${rest.internal}`],
        className
      )}
      ref={innerRef}
      {...rest}
    />
  );
});
